import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingPricing(props) {
  const oldData = (props.listingData && props.listingData.catalogData) || {};

  const [pricing, setPricing] = useState({
    mrp: "",
    salePrice: "",
    minPrice: "",
    maxPrice: ""
  });
  const [currency, setCurrency] = useState("");

  useEffect(() => {
    if (props.listingData) {
      
      const formData = props.listingData.formData || {};
      const savedPricing = props.listingData.pricing || {};

      const fetchedCurrency = props.listingData.currency || formData.currency || "";
      setCurrency(fetchedCurrency);
      setPricing({
        mrp: savedPricing.mrp || formData.price || "",
        salePrice: savedPricing.salePrice || formData.salePrice || "",
        minPrice: savedPricing.minPrice || formData.minPrice || "",
        maxPrice: savedPricing.maxPrice || formData.maxPrice || ""
      });
    }
  }, [props.listingData]);

  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPricing(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNext = () => {
    if (props.setListingData) {
      props.setListingData(prev => ({
        ...prev,
        currency: currency,
        pricing: pricing
      }));
    }
    props.nextStep();
  };

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 7 : Pricing</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">
            
            {/* Column Headers */}
            <Row className="mb-4 text-center">
              <Col md={2} className="text-left"></Col>
              <Col md={4} className="text-left">
                <span className="text-muted"><b>Old Value</b></span>
              </Col>
              <Col md={6} className="text-left">
                <span className="text-muted"><b>New Value</b></span>
              </Col>
            </Row>

            {/* Currency */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Currency : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.currency || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  value={currency}
                  onChange={handleCurrencyChange}
                  placeholder="e.g., USD"
                />
              </Col>
            </Row>

            {/* MRP */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">MRP : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.price || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="mrp"
                  value={pricing.mrp}
                  onChange={handleChange}
                  placeholder="Enter MRP"
                />
              </Col>
            </Row>

            {/* Sale Price */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Sale Price : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.salePrice || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="salePrice"
                  value={pricing.salePrice}
                  onChange={handleChange}
                  placeholder="Enter Sale Price"
                />
              </Col>
            </Row>

            {/* Minimum Price */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Minimum Price :</Col>
              <Col md={4}>
                <p className="mb-0">{oldData.minPrice || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="minPrice"
                  value={pricing.minPrice}
                  onChange={handleChange}
                  placeholder="Enter Minimum Price"
                />
              </Col>
            </Row>

            {/* Maximum Price */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">Maximum Price : </Col>
              <Col md={4}>
                <p className="mb-0">{oldData.maxPrice || "N/A"}</p>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  name="maxPrice"
                  value={pricing.maxPrice}
                  onChange={handleChange}
                  placeholder="Enter Maximum Price"
                />
              </Col>
            </Row>

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>
          <button
            className="btn btn-primary"
            onClick={handleNext}
          >
            Next →
          </button>
        </Col>
      </Row>
    </Container>
  );
}

export default ProductListingPricing;